<app-table [config]="tableConfig" [data]="connectionRights"></app-table>
